/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ApplyInputs */

const en_apply = /** @type {(inputs: ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const fr_apply = /** @type {(inputs: ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer`)
};

const de_apply = /** @type {(inputs: ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwenden`)
};

const it_apply = /** @type {(inputs: ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fare domanda a`)
};

const ru_apply = /** @type {(inputs: ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применять`)
};

const es_apply = /** @type {(inputs: ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

const zh_cn2_apply = /** @type {(inputs: ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`申请`)
};

const ja_apply = /** @type {(inputs: ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`適用する`)
};

const hi_apply = /** @type {(inputs: ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आवेदन करना`)
};

const pt_pt2_apply = /** @type {(inputs: ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {ApplyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply = /** @type {((inputs?: ApplyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ApplyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_apply(inputs)
	if (locale === "de") return de_apply(inputs)
	if (locale === "it") return it_apply(inputs)
	if (locale === "ru") return ru_apply(inputs)
	if (locale === "es") return es_apply(inputs)
	if (locale === "zh-CN") return zh_cn2_apply(inputs)
	if (locale === "ja") return ja_apply(inputs)
	if (locale === "hi") return hi_apply(inputs)
	if (locale === "pt-PT") return pt_pt2_apply(inputs)
	return en_apply(inputs)
});